export const packageList = [
  {
    name: 'kyemap',
    activeRule: ['kyemap', 'gis'],
  },
  {
    name: 'kyemap_areaops',
    activeRule: ['kyemap-areaops'],
  },
  {
    name: 'kyemap_open',
    activeRule: ['kyemap-open'],
  },
  {
    name: 'kyemap_recommend',
    activeRule: ['kyemap-recommend']
  },
  {
    name: 'kyemap_ddreport',
    activeRule: ['kyemap-ddreport']
  },
  {
    name: 'kyemap_olreport',
    activeRule: ['kyemap-olreport']
  },
  {
    name: 'kyemap_intelligence',
    activeRule: ['kyemap-intelligence']
  },
  {
    name: 'kyemap_fence',
    activeRule: ['kyemap-fence'],
  },
  {
    name: 'kyemap_track',
    activeRule: ['kyemap-track'],
  },
  {
    name: 'kyemap_dispatch',
    activeRule: ['kyemap-dispatch'],
  },
]

export const remoteModuleConfig = {
  dev: ['kyemap', 'kyemap_areaops', 'kyemap_open', 'kyemap_recommend', 'kyemap_ddreport', 'kyemap_olreport', 'kyemap_intelligence', 'kyemap_fence', 'kyemap_track', 'kyemap_dispatch'],
  stg: ['kyemap', 'kyemap_areaops', 'kyemap_open', 'kyemap_recommend', 'kyemap_ddreport', 'kyemap_olreport', 'kyemap_intelligence', 'kyemap_fence', 'kyemap_track', 'kyemap_dispatch'],
  uat: ['kyemap', 'kyemap_areaops', 'kyemap_open', 'kyemap_recommend', 'kyemap_ddreport', 'kyemap_olreport', 'kyemap_intelligence', 'kyemap_fence', 'kyemap_track', 'kyemap_dispatch'],
  prd: ['kyemap', 'kyemap_areaops', 'kyemap_open', 'kyemap_recommend', 'kyemap_ddreport', 'kyemap_olreport', 'kyemap_intelligence', 'kyemap_fence', 'kyemap_track', 'kyemap_dispatch'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/map/index.js